import {
  CCol,
  CForm,
  CFormFeedback,
  CFormLabel,
  CFormSelect,
  CLoadingButton,
} from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ToastComponent from 'src/components/common/TaostComponent'
import HeadToHeadService from 'src/service/HeadToHeadService'
const FinalResult = (props) => {
  const [loader, setLoader] = useState(false)
  const [winnerValue, setWinnerValue] = useState(false)
  const [runnerUpValue, setRunnerUpValue] = useState(false)
  const validationSchema = Yup.object().shape({
    winner: Yup.string()
      .required('Winner is required')
      .test('notSame', 'Winner and Runner up cannot be the same', function (value) {
        const runnerupValue = this.parent.runnerup
        return value !== runnerupValue
      }),
    runnerup: Yup.string()
      .required('Runner up is required')
      .test('notSame', 'Winner and Runner up cannot be the same', function (value) {
        const winnerValue = this.parent.winner
        return value !== winnerValue
      }),
  })
  const formik = useFormik({
    initialValues: {
      winner: props.winnerData?.winner,
      runnerup: props.winnerData?.runnerup,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (data, actions) => {
      HeadToHeadService.saveHeadToHeadWinner(data).then((res) => {
        if (res.success) {
          ToastComponent(res.message, 'success')
          setLoader(false)
        }
      })
    },
  })

  const handleWinnerChange = (value) => {
    console.log('value', value)
    setWinnerValue(value)
  }
  const handleRunnerUpChange = (value) => {
    setRunnerUpValue(value)
  }

  return (
    <>
      <CForm className="row g-3" onSubmit={formik.handleSubmit}>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="position">
            Select Winner
          </CFormLabel>
          <CFormSelect
            aria-label="select position"
            name="winner"
            className={
              'form-control' + (formik.errors.winner && formik.touched.winner ? ' is-invalid' : '')
            }
            defaultValue={formik.values.winner}
            // onChange={formik.handleChange}
            onChange={(event) => {
              formik.setTouched({
                ...formik.touched,
                winner: true,
              })
              formik.setFieldValue(`winner`, event.target.value)
              handleWinnerChange(event.target.value)
            }}
            id="winner"
          >
            <option value={0}>Select winner</option>
            {props.userList &&
              props.userList.map((item, key) => (
                <option value={item?.user_id} key={key}>
                  {item?.username}
                </option>
              ))}
          </CFormSelect>
          {formik.errors.winner && formik.touched.winner && (
            <CFormFeedback invalid>{formik.errors.winner}</CFormFeedback>
          )}
        </CCol>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="position">
            Select runner-up
          </CFormLabel>
          <CFormSelect
            aria-label="select position"
            name="runnerup"
            className={
              'form-control' +
              (formik.errors.runnerup && formik.touched.runnerup ? ' is-invalid' : '')
            }
            defaultValue={formik.values.runnerup}
            onChange={(event) => {
              formik.setTouched({
                ...formik.touched,
                runnerup: true,
              })
              formik.setFieldValue(`runnerup`, event.target.value)
              handleRunnerUpChange(event.target.value)
            }}
            id="runnerup"
          >
            <option value={0}>Select Runner-up</option>
            {props.userList &&
              props.userList.map((item, key) => (
                <option value={item?.user_id} key={key}>
                  {item?.username}
                </option>
              ))}
          </CFormSelect>
          {formik.errors.runnerup && formik.touched.runnerup && (
            <CFormFeedback invalid>{formik.errors.runnerup}</CFormFeedback>
          )}
        </CCol>

        <CCol md={6}>
          <CLoadingButton type="submit" color="success" variant="outline" loading={loader}>
            Save
          </CLoadingButton>
        </CCol>
      </CForm>
    </>
  )
}

export default FinalResult
